import { atom } from 'jotai';

import { ProductDetail } from '../Entities/Product.entity';

const eligibleProductAtom = atom<ProductDetail | undefined>(undefined);

export { eligibleProductAtom };
